import { gql } from '@apollo/client';

export const SAVED_PUBLICATIONS_QUERY = gql`
    query getSavedPublications {
        publications {
            recordId
            title
            url
            image
            formats
        }
    }
`;

export const SAVE_PUBLICATION = gql`
    mutation SavePublication($recordId: Int!) {
        savePublication(recordId: $recordId) {
            publication {
                recordId
            }
        }
    }
`;

export const REMOVE_PUBLICATION = gql`
    mutation RemovePublication($recordId: Int!) {
        removePublication(recordId: $recordId) {
            publication {
                recordId
            }
        }
    }
`;
